import React from 'react';

export const useClonedChildrenWithRefs = ({
  children,
  isExpanded = false,
  minVisibleChildren = Infinity,
}: {
  children: React.ReactNode;
  isExpanded?: boolean;
  minVisibleChildren?: number;
}) => {
  const childrenRefs =
    React.Children.map<React.RefObject<HTMLDivElement>, React.ReactNode>(
      children,
      React.createRef
    ) || [];

  const clonedChildrenWithRefs = React.Children.map(children, (child, i) => {
    return (
      <div ref={childrenRefs[i]} aria-hidden={isExpanded ? false : i + 1 > minVisibleChildren}>
        {child}
      </div>
    );
  });

  return { childrenRefs, clonedChildrenWithRefs };
};
